import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { isUndefined } from 'lodash';
import { SyntheticEvent, useCallback, useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import NumberInput from 'src/components/NumberInput';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import { stopPropagation } from 'src/utils';
import { getBgColor } from 'src/utils/icons';

const ForecastYearAmountCell = (props: GridCellProps) => {
  const { isEditMode, hasManageBudgetPermission, dropDownYearValue, getIsLocked } =
    useViewCheckbook();
  const { dataItem, dataIndex, field = '', onChange } = props;
  const { value, displayValue } = useGridCellDisplayValue(props);
  const { isDeleted } = dataItem;

  const handleForecastChange = useCallback(
    (e: TextBoxChangeEvent) => {
      onChange?.({
        dataIndex,
        dataItem,
        field,
        syntheticEvent: e.syntheticEvent,
        value: e.value,
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  const details = getIsLocked({
    field,
    dataItem,
    dropDownYearValue,
  });

  const { isLocked, isCurrentPeriodPassed, currentPeriodEditable } = details;
  const isEditable = useMemo(
    () =>
      !isLocked &&
      isEditMode &&
      hasManageBudgetPermission &&
      !isDeleted &&
      !isCurrentPeriodPassed &&
      dropDownYearValue &&
      currentPeriodEditable,
    [
      isLocked,
      isEditMode,
      hasManageBudgetPermission,
      isDeleted,
      isCurrentPeriodPassed,
      dropDownYearValue,
      currentPeriodEditable,
    ]
  );

  const handleBlur = useCallback(() => {
    if (isEditable) {
      const newValue = isUndefined(value) || value === '' || isNaN(Number(value)) ? '0' : value;
      const dummyEvent = {} as SyntheticEvent;

      onChange?.({
        dataIndex: dataIndex,
        dataItem: dataItem,
        field: field,
        syntheticEvent: dummyEvent,
        value: newValue,
      });
    }
  }, [dataIndex, dataItem, field, isEditable, onChange, value]);

  return (
    <GridCellBase
      {...props}
      title={displayValue}
      className={`${getBgColor([], dataItem?.warnings?.[field as string])} ${
        !isEditMode && Number(value) < 0 ? 'budget-cell-color' : ''
      } !text-right`}
      rowSelectionEnabled
    >
      {isEditable ? (
        <span onClick={stopPropagation}>
          <NumberInput
            value={isUndefined(value) ? '' : String(value)}
            onBlur={handleBlur}
            onChange={handleForecastChange}
            prefix="$"
          />
        </span>
      ) : (
        <span>{displayValue}</span>
      )}
    </GridCellBase>
  );
};

export default ForecastYearAmountCell;
